import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useLang } from "../../i18n";
import { getConsent, setConsent, hasGA } from "../../lib/analytics";
import { Cookie } from "lucide-react";

export const CookieConsent = () => {
  const { lang } = useLang();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (hasGA && !getConsent()) {
      const t = setTimeout(() => setShow(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const decide = (v) => { setConsent(v); setShow(false); };

  const t = {
    fr: {
      txt: "Nous utilisons des cookies de mesure d'audience (Google Analytics) pour comprendre l'usage du site. Le suivi statistique interne, lui, reste anonyme et sans cookie.",
      accept: "Accepter", refuse: "Refuser",
    },
    en: {
      txt: "We use audience-measurement cookies (Google Analytics) to understand site usage. Our internal statistics remain anonymous and cookie-free.",
      accept: "Accept", refuse: "Decline",
    },
  }[lang];

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.76, 0, 0.24, 1] }}
          className="fixed bottom-4 inset-x-4 md:left-6 md:right-auto md:max-w-md z-[60]"
          data-testid="cookie-consent"
        >
          <div className="bg-[rgba(12,12,13,0.92)] backdrop-blur-xl border border-white/12 rounded-2xl p-5 shadow-2xl">
            <div className="flex items-start gap-3">
              <span className="shrink-0 w-9 h-9 rounded-full bg-[var(--primary)]/15 text-primary-c flex items-center justify-center"><Cookie size={17} /></span>
              <p className="text-white/70 text-sm leading-relaxed">{t.txt}</p>
            </div>
            <div className="mt-4 flex gap-3">
              <button onClick={() => decide("granted")} data-testid="cookie-accept" className="flex-1 bg-[var(--primary)] text-black font-medium text-sm py-2.5 rounded-full hover:bg-white transition-colors">{t.accept}</button>
              <button onClick={() => decide("denied")} data-testid="cookie-refuse" className="flex-1 border border-white/20 text-white/80 text-sm py-2.5 rounded-full hover:border-white/40 transition-colors">{t.refuse}</button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
